import helper, { getSlugByLang, getSlugNameByLang } from "../common/Helper";
import noTour from "../assest/myImages/no-tour-img.png";
import ListLoading from "./ListLoading";
import Attraction from "./Skeletons/Attraction";
import { Link } from "react-router-dom";
import moment from "moment";
import { Pagination as RecordPagination } from './Pagination';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector } from "react-redux";

const BlogListCard = ({
    blogList,
    nextPageUrl,
    isBlogsLoading,
    // onClickLoadMore,
    isLoading,
    totalItems,
    totalPages,
    currentPage,
    onPageChange
}) => {
    const options = {
        loop: false,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    };
    function decodeHtmlEntities(text) {
        let textarea = document.createElement("textarea");
        textarea.innerHTML = text;
        return textarea.value;
    }

    function extractFirstLinesWithLimit(html, numLines = 4, charLimit = 200) {
        // Remove all HTML tags
        html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, ''); // Remove stype tag
        html = html.replace(/<meta[^>]*>/gi, ''); // Remove <meta> tags

        let text = html.replace(/<[^>]*>/g, '');

        // Decode HTML entities
        text = decodeHtmlEntities(text);

        // Remove extra spaces
        text = text.replace(/\s+/g, ' ').trim();

        // Split text into lines
        let lines = text.split(/\r?\n/).filter(line => line.trim() !== '');

        // Get first `numLines` lines and join them
        let limitedText = lines.slice(0, numLines).join(' ');

        // Limit the character length
        return limitedText.length > charLimit ? limitedText.substring(0, charLimit).trim() + '...' : limitedText;
    }

    const user = useSelector((state) => state.user);
    const slugField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)

    return (
        <section className="pageSection2 blogPage">
            <div className="Section2Box">
                <div className="container">
                    {/* <div className="sectionTitle">
                    <h3>{blogList?.length > 0 && "Explo"}</h3>
                </div> */}
                    {
                        // blogList?.length > 0 &&

                        <div className="placeSecDesktop">
                            <div className="placeSec">
                                <div className="row">

                                    {
                                        isLoading ?
                                            <>
                                                <Attraction records={9} />
                                            </> :
                                            blogList?.length > 0 ?
                                                blogList.map((val, ind) => {


                                                    return (
                                                        <div className="col-lg-4 col-md-6" key={ind}>
                                                            <Link
                                                                // to={'/blog/article/' + val.slug} 
                                                                to={(slugLang ? ('/' + slugLang) : '') + '/blog/article/' + val?.[slugField]}
                                                                style={{ width: "100%", height: "100%" }}>
                                                                <div className="travelBox">
                                                                    <div className="imgBox">
                                                                        <img loading="lazy"
                                                                            src={helper.S3Url + '/' + helper.blogImageDir + '/' + val.listing_image}

                                                                            alt={val?.name}
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = noTour
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="textBox">
                                                                        <p className="oneLine">
                                                                            {/* <i className="fa-solid fa-location-dot"></i> */}
                                                                            {val.category ? val.category?.name : ""}
                                                                            &nbsp;&#x2022; &nbsp;
                                                                            {moment(val?.created_at).format('DD MMM YYYY')}</p>
                                                                        <h6
                                                                            style={{ height: "unset" }}
                                                                            data-bs-toggle="tooltip" data-bs-placement="top"
                                                                            data-bs-custom-class="custom-tooltip"
                                                                            data-bs-title="This top tooltip is themed via CSS variables."
                                                                            title={val.name}>{val.name}</h6>
                                                                        <p>{extractFirstLinesWithLimit(val.content)}</p>

                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                    )
                                                }) :
                                                // <h4>No Blogs Found</h4>
                                                <></>
                                    }
                                </div>
                            </div>
                        </div>

                    }
                    {
                        // blogList?.length > 0 &&
                        <div className="placeSecMobile">
                            {
                                isLoading ?
                                    <>
                                        <Attraction records={1} />
                                    </> :
                                    <OwlCarousel className='owl-theme' key={blogList.length} id="mobileSlider-1" {...options}>
                                        {
                                            blogList?.length > 0 &&
                                            blogList.map((val, ind) => {


                                                return (
                                                    <div className="col-lg-4 col-md-6" key={ind}>
                                                        <Link
                                                            // to={'/blog/article/' + val.slug}
                                                            to={(slugLang ? ('/' + slugLang) : '') + '/blog/article/' + val?.[slugField]}
                                                            style={{ width: "100%", height: "100%" }}>
                                                            <div className="travelBox">
                                                                <div className="imgBox">
                                                                    <img loading="lazy"
                                                                        src={helper.S3Url + '/' + helper.blogImageDir + '/' + val.listing_image}

                                                                        alt={val?.name}
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.src = noTour
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="textBox">
                                                                    <p className="oneLine">
                                                                        {/* <i className="fa-solid fa-location-dot"></i> */}
                                                                        {val.category ? val.category?.name : ""}
                                                                        &nbsp;&#x2022; &nbsp;
                                                                        {moment(val?.created_at).format('DD MMM YYYY')}</p>
                                                                    <h6
                                                                        style={{ height: "unset" }}
                                                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                                                        data-bs-custom-class="custom-tooltip"
                                                                        data-bs-title="This top tooltip is themed via CSS variables."
                                                                        title={val.name}>{val.name}</h6>
                                                                    <p>{extractFirstLinesWithLimit(val.content)}</p>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </OwlCarousel>
                            }
                        </div>
                    }

                    {
                        blogList.length > 0 &&
                        <RecordPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={onPageChange}
                            totalItems={totalItems}
                        />
                    }
                    {/* 
                    {
                        isBlogsLoading ? <ListLoading /> :
                            blogList.length > 0 && nextPageUrl &&

                            <div className="showMore">
                                <button
                                    className="btn showMoreBtn"
                                    onClick={() => onClickLoadMore('blogs', nextPageUrl.split('=')[1])}

                                >Show more <i className="fa-solid fa-chevron-right"></i></button>
                            </div>
                    } */}
                </div>
            </div>
        </section>
    )

}
export default BlogListCard